/**
 * @flow
 * @relayHash 409ff27b176aefe2aaf2460f1efffa8a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type abortScheduledInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type abortScheduledCampaignMutationVariables = {|
  input: abortScheduledInput
|};
export type abortScheduledCampaignMutationResponse = {|
  +abortScheduled: ?{|
    +clientMutationId: ?string,
    +hyblast: ?{|
      +id: string
    |},
  |}
|};
export type abortScheduledCampaignMutation = {|
  variables: abortScheduledCampaignMutationVariables,
  response: abortScheduledCampaignMutationResponse,
|};
*/


/*
mutation abortScheduledCampaignMutation(
  $input: abortScheduledInput!
) {
  abortScheduled(input: $input) {
    clientMutationId
    hyblast {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "abortScheduledInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "abortScheduled",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "abortScheduledPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyblast",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyblast",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "abortScheduledCampaignMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "abortScheduledCampaignMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "abortScheduledCampaignMutation",
    "id": null,
    "text": "mutation abortScheduledCampaignMutation(\n  $input: abortScheduledInput!\n) {\n  abortScheduled(input: $input) {\n    clientMutationId\n    hyblast {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1eb0692ecb100e5371ec22b12116746e';
module.exports = node;
